import { Box, BoxProps, Text, useColorModeValue } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

import { stringOfLength } from '_helpers/index';

export type SpinnerTextProps = BoxProps;

const defaultProps = {
  fontSize: 'md',
  fontWeight: 'medium',
  lineHeight: '150%',
  textAlign: 'center',
  maxWidth: '320px'
};

const propTypes = {
  children: PropTypes.string.isRequired,
  fontSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl']),
  fontWeight: PropTypes.string,
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textAlign: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const MIN_TEXT_LENGTH = 1;
const MAX_TEXT_LENGTH = 88;

const SpinnerText = (props: SpinnerTextProps): React.ReactElement => {
  const { children, ...rest } = props;

  return (
    <Box marginTop="16px">
      <Text color={useColorModeValue('black.lighter', 'silver.lighter')} {...rest}>
        {stringOfLength(children, MIN_TEXT_LENGTH, MAX_TEXT_LENGTH)}
      </Text>
    </Box>
  );
};

SpinnerText.propTypes = propTypes;
SpinnerText.defaultProps = defaultProps;
SpinnerText.displayName = DisplayNames.SpinnerText;

export default SpinnerText;
